module.exports = __webpack_public_path__ + "img/Miranda_Klein.2fab31b1.png";